<template>
  <div class="panel panel-default version-card">
    <div class="panel-heading clearfix">
      <template v-if="isAdmin">
        <div class="pull-left">
          <button class="btn btn-default btn-sm" @click="$emit('send', version)">
            <span class="fas fa-copy"></span> Send Copy
          </button>
        </div>
      </template>
      <div class="pull-right">
        <button class="btn btn-default btn-sm" @click="$emit('share', version)">
          <span class="fas fa-user-friends"></span> Share
        </button>
        <div class="btn-group">
          <button
            data-testid="publish-btn-cy"
            class="btn btn-default btn-sm"
            @click="$emit('publish', version)"
          >
            <span class="fas fa-rocket"></span> Publish
          </button>

          <button
            type="button"
            class="btn btn-sm btn-default dropdown-toggle"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
            data-testid="dropdown-toggle"
          >
            <span style="font-weight: bolder" class="fas fa-ellipsis-v"></span>
            <span class="sr-only">Toggle Dropdown</span>
          </button>
          <ul class="dropdown-menu pull-right" data-testid="dropdown-menu">
            <li :class="version.isActive ? 'disabled' : null">
              <a @click.prevent="version.isActive ? null : $emit('delete', version)" href="#">
                <span class="fas fa-trash-alt"></span> Delete
              </a>
            </li>
            <li>
              <a @click.prevent="$emit('duplicate', version.versionKey)" href="#">
                <span class="fas fa-copy"></span> Duplicate</a
              >
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="panel-body text-center">
      <h4 class="mt-0 mb-20">{{ version.versionName }}</h4>
      <router-link
        :class="['btn btn-sm btn-primary btn-block']"
        :disabled="version.isActive ? true : false"
        tag="button"
        :to="{ name: 'skills', params: { resourceKey: version.versionKey } }"
      >
        <span class="fas fa-pencil mr-5"></span> Edit
      </router-link>
    </div>
    <template v-if="isAdmin">
      <div class="panel-footer">
        <small
          ><span class="bold-text">Created by: </span>
          {{ version.authorName || 'Internal build' }}</small
        >
      </div>
    </template>
  </div>
</template>

<script>
  export default {
    props: {
      version: {
        type: Object,
        required: true,
      },
      isAdmin: {
        type: Boolean,
        default: false,
      },
    },
  };
</script>

<style lang="scss" scoped>
  .version-card {
    .panel-heading,
    .panel-footer {
      background: white;
    }
  }
</style>
